const styles = theme => ({
  body: {
    marginBottom: theme.spacing.unit * 2.375
  },
  panelHeader: {
    padding: theme.spacing.unit * 3
  },
  expandButton: {
    //TODO this style along with PanelHeader need to be thought about maybe being global
    marginTop: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3
  },
  collapsePanelBodyRoot: {
    marginTop: '0 !important',
    paddingTop: '0 !important'
  },
  sectionHeading: {},
  gridContainer: {
    paddingTop: theme.spacing.unit * 3,
    paddingLeft: theme.spacing.unit * 3,
    paddingRight: theme.spacing.unit * 3,
    paddingBottom: theme.spacing.unit * 6
  },
  titleWrapper: {
    display: 'flex'
  },
  title: {
    flex: 'none'
  },
  hidden: {
    display: 'none'
  },
  buttonContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    height: '100%'
  },
  sectionContainer: {
    marginTop: '27px'
  },
  destinationPanel: {
    flexDirection: 'column'
  },
  formattedAddress: {
    paddingTop: theme.spacing.unit * 0.5,
    paddingLeft: theme.spacing.unit * 2,
    lineHeight: '24px'
  },
  rowFlex: { flex: 1 },
  expanded: {
    margin: '0 !important',
    minHeight: '48px'
  },
  panelExpanded: {
    padding: '4px 0'
  },
  expandIcon: {
    padding: '14px'
  }
});

export default styles;
